
































import { Component, Mixins, Vue, Ref } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import DatePickerBase from '@/components/common/atoms/DatePickerBase.vue'
import LinkArea from '@/components/academy/organisms/LinkArea.vue'
import StudentForStudyTable from '@/components/academy/organisms/StudentForStudyTable.vue'
import StudentForStudyApis, {
  StudyData,
  StudentForStudyData,
  StudentForStudySearchQuery,
} from '@/mixins/requests/academy/StudentForStudyApis.vue'
import PaginationButton from '@/components/common/organisms/PaginationButton.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    DatePickerBase,
    StudentForStudyTable,
    LinkArea,
    PaginationButton,
  },
})
export default class StudentForStudy extends Mixins(StudentForStudyApis) {
  private bcbtCode = ''
  private branchName = ''
  private gradeId = ''
  private nickname = ''
  private studiedAt = ''
  private currentQuery: StudentForStudySearchQuery = {}

  private studyData: StudyData | null = null
  private studentForStudyList: StudentForStudyData[] = []

  // ref: ページネーション
  @Ref() paginationButton!: PaginationButton

  private get studyContentId() {
    return this.$route.params['studyContentId']
  }

  private get exportColortype() {
    return (this.studyData && this.studyData.isScoring) || this.studentForStudyList.length === 0
      ? 'pointer-events-none'
      : ''
  }

  private async mounted() {
    Vue.prototype.$loading.start()
    try {
      this.studyData = await this.getStudy(this.studyContentId)
      await this.search()
    } catch (e) {
      if (e.response.status === 404) alert('指定のテストが存在しません')
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async onClickSearch() {
    Vue.prototype.$loading.start()
    try {
      await this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async onClickExport() {
    Vue.prototype.$loading.start()
    try {
      const exportInfo = await this.export(this.studyContentId)
      const fileLink = document.createElement('a')
      fileLink.href = exportInfo.url
      fileLink.download = exportInfo.filename
      fileLink.click()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async search() {
    this.currentQuery = {}
    if (this.bcbtCode) {
      this.currentQuery.bcbtCode = this.bcbtCode
    }
    if (this.branchName) {
      this.currentQuery.branchName = this.branchName
    }
    if (this.gradeId) {
      this.currentQuery.gradeId = this.gradeId
    }
    if (this.nickname) {
      this.currentQuery.nickname = this.nickname
    }
    if (this.studiedAt) {
      this.currentQuery.studiedAt = this.studiedAt
    }

    await this.loadStudentForStudyList()
  }

  private onClickComfirmButton(bcbtCode: string) {
    // 受験結果画面を別タブで開く
    window.open(`/academy/study-result/${bcbtCode}/${this.studyContentId}`, '_blank')
  }

  private async loadStudentForStudyList() {
    const studentForStudyObject = await this.searchStudentForStudy(
      this.paginationButton.paginationCurrentPage,
      this.studyContentId,
      this.currentQuery
    )
    this.studentForStudyList = studentForStudyObject.responses
    this.paginationButton.paging(studentForStudyObject.pagination)
  }

  private async onClickPaginationButton() {
    await this.search()
  }
}
